/**
 * Application entry point.
 *
 * @module main
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import panic from './lib/panic'

// Create Vue app
const app = createApp(App)

// Install plugins
app.use(createPinia())
app.use(router)

// Mount app
app.mount('#app')

// Initialize panic after DOM is ready
panic.init()

// Completed
